import React, { useState } from "react";
import Button from "./UI/Button";
import {
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "@/firebase/firebaseConfig";

import { useRememberUser } from "@/utils/useRememberUser";
import { PasswordInput } from "./UI/PasswordInput";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";
import { FirebaseError } from "firebase/app";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    email,
    setEmail,
    password,
    setPassword,
    rememberUser,
    setRememberUser,
    saveCredentials,
  } = useRememberUser();



// Устанавливаем долговременную сессию один раз
setPersistence(auth, browserLocalPersistence).catch(console.error);

// --------------------------------------------------
// Функция входа
const signIn = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    // Авторизация через email и пароль
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Принудительное обновление токена для стабильной сессии на всех устройствах
    await user.getIdToken(true);

    // Сохраняем данные, если пользователь выбрал "запомнить"
    saveCredentials(rememberUser, email, password);

    setLoading(false);
  } catch (error) {
    setLoading(false);

    if (error instanceof FirebaseError) {
      const errorCode = error.message || "default";
      setErrorMessage(errorMessages[errorCode] || errorMessages.default);
    } else {
      setErrorMessage(errorMessages.default);
    }
  }
};

  return (
    <>
      <p className="authentication-box__title">Войти</p>
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}

      <input
        className={`input `}
        required
        value={email}
        id="email"
        name="email"
        type="email"
        placeholder="you@example.com"
        onChange={(event) => setEmail(event.target.value)}
      />

      <PasswordInput value={password} onChange={setPassword} />

      <div className="authentication-box-buttons">
        <div>
          <input
            className={`input `}
            onChange={(event) => setRememberUser(event.target.checked)}
            id="remember"
            name="remember"
            value={"remember"}
            type="checkbox"
          />
          <label htmlFor="remember">{""} Запомнить</label>
        </div>
        <a className="authentication-box__link" href="/auth/reset">
          Забыли пароль?
        </a>
      </div>

      {loading ? (
        <Button title="Отправить" color="black" disabled onClick={() => null} />
      ) : (
        <Button title="Отправить" color="black" onClick={signIn} />
      )}

      <p className="authentication-box__text">
        Нет аккаунта?{" "}
        <a className="authentication-box__link" href="/auth/sign-up">
          Зарегистрироваться
        </a>
      </p>
    </>
  );
};

export default Login;
